import { createContext } from 'react'

import { createWebOfficeStore } from '../store/createStore'

export const WebOfficeStoreContext = createContext<
  ReturnType<typeof createWebOfficeStore> | undefined
>(undefined)
